import { render, staticRenderFns } from "./PokemonCard.vue?vue&type=template&id=15987f6e"
import script from "./PokemonCard.vue?vue&type=script&lang=js"
export * from "./PokemonCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports